import React, { Component } from 'react';

import { Loading, SERVER_ERROR } from 'commons';
import request from '../request';

class ConfirmInvite extends Component {
    state = {
        loading: true,
        requestId: this.props.match.params.requestId,
        requestExpiredOrInvalid: false,
        error: false
    };

    async componentDidMount() {
        try {
            const res = await request(`/session/invite/${this.state.requestId}`);

            this.setState({ loading: false });

            if (res.status >= 500) {
                this.setState(SERVER_ERROR);
                return;
            } else if (res.status >= 400) {
                this.setState({ requestExpiredOrInvalid: true });
                return;
            }

            const data = await res.json();

            if (data.redirectUri) {
                setTimeout(() => window.location.href = data.redirectUri, 3000);
            } else {
                this.setState(SERVER_ERROR);
            }
        } catch (error) {
            this.setState({ loading: false, ...SERVER_ERROR });
        }
    }

    renderForm() {
        if (this.state.loading) return <Loading />;
        if (this.state.requestExpiredOrInvalid) {
            return <div className="invite">The invite link is invalid or expired.</div>;
        }
        if (this.state.error) return <div className="margin-top-large">{this.state.error}</div>;

        return <div className="invite">Please wait while we are confirming your User Account...</div>;
    }

    render() {
        return (
            <div className="boxed-container">
                {this.renderForm()}
            </div>
        );
    }
}

export default ConfirmInvite;